import templateUrl from './corporation-audit-log-picker.component.html'

export const CorporationAuditLogPickerComponent = {
    controller: CorporationAuditLogPickerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        auditLogs: "<",
        resultLimit: "<", // Maximum number of results to display in the list when unfiltered.
        pageNumber: "<",
        pageSize: "<",
        totalEntries: "<",
        onSelectAuditLog: "&",
        onChangePage: "&",
        onChangeSearchText: "&"
    }
};

function CorporationAuditLogPickerController() {
    'ngInject';
    const vm = this;
    vm.auditLogs;
    vm.resultLimit = 25;
    vm.resultFilter;
    vm.onSelectAuditLog;
    vm.changePage = changePage
    vm.changeSearchText = changeSearchText;

    function changePage() {
        vm.onChangePage({ pageNumber: vm.pageNumber });
    }

    function changeSearchText() {
        vm.onChangeSearchText({ text: vm.resultFilter });
    }
}
